import Button from "../../b-molecules/buttons/Button";
import style from "./DialogNew.module.css";

const DialogNew = (props) => {
  return (
    <div className={`${style.modalOverlay} ${props.show && style.show} ${props.variants ? props.variants.map((i) => style[i]).join(" ") : null
      }`}>
      <div className={style.background} onClick={props.onClose} ></div>
      <div
        className={style.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        {props.title ? (
          <div className={style.modalHeader}>
            <h2 className={style.modalTitle}>{props.title}</h2>
          </div>
        ) : null}

        <div className={`${style.modalBody}`}>
          {props.children}
        </div>

        <div className={style.modalFooter}>
          {props.actions && props.actions.map((action, index) => (
            <Button key={index} onClick={action.onClick}>{action.name}</Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DialogNew;